// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusApproved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.212 2.843 2.168-.308a1.998 1.998 0 0 1 2.246 1.64l.379 2.166 1.934 1.03a2.01 2.01 0 0 1 .858 2.653L21.835 12l.962 1.976a2.01 2.01 0 0 1-.858 2.652l-1.934 1.031-.379 2.166a1.998 1.998 0 0 1-2.246 1.64l-2.168-.308-1.573 1.529a1.99 1.99 0 0 1-2.777 0l-1.574-1.53-2.168.309a1.998 1.998 0 0 1-2.246-1.64l-.379-2.166-1.934-1.03a2.01 2.01 0 0 1-.858-2.653L2.665 12l-.962-1.976a2.01 2.01 0 0 1 .858-2.652L4.495 6.34l.379-2.166a1.998 1.998 0 0 1 2.246-1.64l2.168.308 1.573-1.529a1.99 1.99 0 0 1 2.777 0zm2.448 1.678-3.135.446-2.275-2.211-2.275 2.21-3.134-.445-.547 3.132-2.797 1.49L4.887 12l-1.39 2.857 2.797 1.49.547 3.132 3.134-.446 2.275 2.211 2.275-2.21 3.135.445.546-3.132 2.797-1.49L19.613 12l1.39-2.857-2.797-1.49zM9.968 15.87l-2.842-2.926a.453.453 0 0 1 0-.628l.608-.625a.423.423 0 0 1 .61 0l1.93 1.979 5.38-5.54a.423.423 0 0 1 .612.001l.609.631a.454.454 0 0 1-.001.627l-6.295 6.48a.423.423 0 0 1-.61 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStatusApproved;
